import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { ControlLabel, Button } from 'react-bootstrap';
import { reduxForm, Field } from 'redux-form';
import { translate } from 'react-i18next';

import resetPasswordPerformValidator from '../../utils/resetPasswordPerformValidator';
import SecurityBoxLogo from '../SecurityBoxLogo';
import SecurityBoxInputsWrap from '../SecurityBoxInputsWrap';
import SecurityBoxInput from '../SecurityBoxInput';

import * as resetPassword from '../../action-creators/resetPassword';

const ResetPasswordPerformContainer = translate(['ui'])(
  class extends React.Component {
    constructor(props) {
      super(props);
      this.onSubmit = this.onSubmit.bind(this);
      this.state = { success: false };
    }

    componentWillMount() {
      const { tokenVerification, location } = this.props;

      const params = new URLSearchParams(location.search);
      const token = params.get('token');
      tokenVerification(token);
    }

    async onSubmit({ password }) {
      const { token, updateTokenVerificationError, resetPasswordPerform } = this.props;

      try {
        const res = await resetPasswordPerform(token, password);
        if (res.ok) {
          this.setState({ success: true });
          // history.push('/login');
        } else {
          const data = await res.json();
          updateTokenVerificationError(data.errors[0].code);
        }
      } catch (err) {
        console.log(err);
      }
    }

    render() {
      const { t, handleSubmit, tokenError, token, email } = this.props;
      return (
        <div className="auth-box auth-box-register">
          <SecurityBoxLogo />
          <div className="small-form" style={{ height: 350 }}>
            <SecurityBoxInputsWrap>
              {/* eslint-disable-next-line no-nested-ternary */}
              {tokenError || !token ? (
                <div style={{ color: 'red' }}>{t(tokenError)}</div>
              ) : // eslint-disable-next-line react/destructuring-assignment
              !this.state.success ? (
                <div>
                  <div>
                    <ControlLabel style={{ fontSize: 18, color: '#252b49', fontWeight: 'normal', marginBottom: 15 }}>
                      {t('create_new_password')}
                    </ControlLabel>
                  </div>
                  <div style={{ marginBottom: 15 }}>
                    <ControlLabel className="control-label-login">{t('Email')}</ControlLabel>
                    <div style={{ color: '#000' }}>{email}</div>
                  </div>
                  <ControlLabel className="control-label-login">
                    {t('Password')}
                    <span style={{ color: 'red' }}>*</span>
                  </ControlLabel>
                  <Field
                    name="password"
                    component={SecurityBoxInput}
                    type="password"
                    placeholder={t('Min length 8 symbols')}
                  />
                  <ControlLabel className="control-label-login">
                    {t('Repeat password')}
                    <span style={{ color: 'red' }}>*</span>
                  </ControlLabel>
                  <Field
                    name="repeatPassword"
                    component={SecurityBoxInput}
                    marginTop="true"
                    type="password"
                    placeholder={t('Min length 8 symbols')}
                  />
                  <div style={{ display: 'flex', justifyContent: 'center', marginTop: 35 }}>
                    <Button bsStyle="primary" style={{ width: 220 }} onClick={handleSubmit(this.onSubmit)}>
                      {t('Get password')}
                    </Button>
                  </div>
                </div>
              ) : (
                <div style={{ paddingTop: 64 }}>
                  <p style={{ fontSize: '18px', paddingBottom: 5, display: 'flex', justifyContent: 'center' }}>
                    <img src="/img/ico_ok.svg" alt="" />
                  </p>
                  <p style={{ textAlign: 'center', fontSize: 14, color: '#252b49', marginTop: 24 }}>
                    {t('reset_success_text')}
                  </p>
                  <p style={{ textAlign: 'center', marginLeft: 5, marginTop: 90 }}>
                    <Link style={{ textDecoration: 'none', color: '#767b92', fontWeight: 500, fontSize: 14 }} to="/">
                      {t('to_main')}
                    </Link>
                  </p>
                </div>
              )}
            </SecurityBoxInputsWrap>
          </div>
        </div>
      );
    }
  }
);

function mapStateToProps(state) {
  return {
    tokenError: state.main.getIn(['resetPassword', 'tokenError']),
    token: state.main.getIn(['resetPassword', 'token']),
    email: state.main.getIn(['resetPassword', 'email'])
  };
}

const ResetPasswordPerformForm = reduxForm({
  form: 'resetPasswordPerform',
  validate: resetPasswordPerformValidator
})(ResetPasswordPerformContainer);

export default connect(mapStateToProps, resetPassword)(ResetPasswordPerformForm);



// WEBPACK FOOTER //
// ./components/resetPassword/ResetPasswordPerformContainer.jsx